import { CNPJ_DIGITS_LENGTH, formatCep, getDigits } from './stringFormat';

export const maskCpfCnpj = (texto) => {
    if (!texto) return '';

    texto = getDigits(texto).slice(0, CNPJ_DIGITS_LENGTH);

    if (texto.length <= 11) {
      texto = texto.replace(/(\d{3})(\d)/, '$1.$2');
      texto = texto.replace(/(\d{3})(\d)/, '$1.$2');
      texto = texto.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    } else if (texto.length <= CNPJ_DIGITS_LENGTH) {
      texto = texto.replace(/^(\d{2})(\d)/, '$1.$2');
      texto = texto.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      texto = texto.replace(/\.(\d{3})(\d)/, '.$1/$2');
      texto = texto.replace(/(\d{4})(\d)/, '$1-$2');
    }

    return texto;
};

export const maskRG = (texto) => {
  texto = getDigits(texto);

  if (texto.length <= 9) {
    texto = texto.replace(/(\d{1})(\d)/, '$1.$2');
    texto = texto.replace(/(\d{3})(\d)/, '$1.$2');
    texto = texto.replace(/(\d{3})(\d{1,3})$/, '$1.$2');
  }

  return texto;
};

export const maskCEP = (texto) => formatCep(texto);

export const maskPhone = (texto) => {
  texto = getDigits(texto);

  if (texto.length < 10) {
    texto = texto.replace(/(\d{2})(\d)/, '($1) $2');
  } else if (texto.length === 10) {
    texto = texto.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else if (texto.length === 11) {
    texto = texto.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  };

  return texto;
};

const BR_COUNTRY_CODE = '55';
const LANDLINE_LENGTH = 10;
const MOBILE_LENGTH = 11;

export const getPhoneDigits = (texto) => {
  const digits = getDigits(texto);

  if (digits.length > MOBILE_LENGTH && digits.startsWith(BR_COUNTRY_CODE)) {
    return digits.slice(BR_COUNTRY_CODE.length);
  }

  return digits;
};

export const isValidPhone = (texto) => {
  const digits = getPhoneDigits(texto);

  if (digits.length !== LANDLINE_LENGTH && digits.length !== MOBILE_LENGTH) return false;
  if (/^(\d)\1+$/.test(digits)) return false;

  const ddd = Number(digits.slice(0, 2));
  if (ddd < 11 || ddd > 99) return false;

  const firstDigit = digits.charAt(2);
  return digits.length === MOBILE_LENGTH ? firstDigit === '9' : /[2-5]/.test(firstDigit);
};
